<template>
  <div class="bg-white p-6 rounded-lg shadow-lg mt-5">
    <h1 class="text-2xl font-bold mb-4">
      Tu pago esta en proceso. Comunicate conmigo para más informacion
    </h1>
    <div class="mt-10">
      <a
        href="https://wa.me/+5492255427173"
        target="_blank"
        rel="noopener noreferrer"
        class="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded"
      >
        <i class="fab fa-whatsapp mr-2"></i>Contactar por WhatsApp</a
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>
